import { render, staticRenderFns } from "./timeAndProductTj.vue?vue&type=template&id=69c1d3a9&scoped=true&"
import script from "./timeAndProductTj.vue?vue&type=script&lang=js&"
export * from "./timeAndProductTj.vue?vue&type=script&lang=js&"
import style0 from "./timeAndProductTj.vue?vue&type=style&index=0&id=69c1d3a9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c1d3a9",
  null
  
)

export default component.exports